// extracted by mini-css-extract-plugin
export default {"container":"List_container__SusNj","list":"List_list__Skt2L"};